import React from 'react';

import Grid from '@material-ui/core/Grid';
import Button from '@material-ui/core/Button';
import Checkbox from '@material-ui/core/Checkbox';
import TextField from '@material-ui/core/TextField';
import api from '../../ApiService';

import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';

import { toast } from 'react-toastify';

export default class AffiliateGroupsEditor extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            loading: true,
            affiliateGroupHospitals: [],
            affiliateGroupName: '',
            filter: 'select',
            loadingHospitals: true,
            isDirty: false,
            isCancel: true
        };
    }

    componentDidMount = async () => {
        let affiliateGroupHospitals = await api.getAffiliateGroupHospitals(this.props.affiliateId, this.props.affiliateGroup.id);
        this.setState({
            affiliateGroupHospitals,
            loadingHospitals: false,
            affiliateGroupName: this.props.affiliateGroup.name
        });
    }

    onClickSave = async () => {
        if (this.state.isNameDirty) {
            var affiliateGroup = {
                id: this.props.affiliateGroup.id,
                affiliateId: this.props.affiliateId,
                name: this.state.affiliateGroupName
            };
            let success = await api.saveAffiliateGroups(affiliateGroup);
            if (success) {
                toast.success(`Affiliate Group Name updated.`);
            }
        }
        if (this.state.isDirty) {
            let items = this.state.affiliateGroupHospitals;
            items = items.filter(item => item.affiliateGroupId === this.props.affiliateGroup.id);
            let success = await api.saveAffiliateGroupHospitals(items);
            if (success) {
                toast.success(`Affiliate Groups updated.`);
            }
        }

        let affiliateGroupHospitals = await api.getAffiliateGroupHospitals(this.props.affiliateId, this.props.affiliateGroup.id);
        this.setState({
            affiliateGroupHospitals,
            isNameDirty: false,
            isDirty: false
        });
    }

    handleChange = (e) => {
        if (e.target.defaultValue === e.target.value) {
            this.setState({
                isNameDirty: false
            });
            return;
        }
        this.setState({
            isNameDirty: true,
            affiliateGroupName: e.target.value
        });
    }

    renderSaveCancel = (columnSpread) => {
        return (
            <Grid item xs={columnSpread} style={{ textAlign: 'right', display: 'flex', justifyContent: 'flex-end', alignItems: 'flex-end' }} >
                <Button variant='contained' color='default' style={{ marginRight: '15px', width: '80px' }} onClick={this.props.onClickCancel} disabled={!this.state.isCancel}>Cancel</Button>
                <Button variant='contained' color='primary' style={{ width: '80px' }} onClick={this.onClickSave} disabled={!this.state.isDirty}>Save</Button>
            </Grid>
        );
    }

    renderDeleteSaveCancel = ( columnSpread) => {
        return (
            <Grid item xs={columnSpread} style={{ textAlign: 'right', display: 'flex', justifyContent: 'flex-end', alignItems: 'flex-end' }} >
                <Button variant='contained' color='default' style={{ marginRight: '15px', width: '80px' }} onClick={this.props.onClickDelete} >Delete</Button>
                <Button variant='contained' color='default' style={{ marginRight: '15px', width: '80px' }} onClick={this.props.onClickCancel} disabled={!this.state.isCancel}>Cancel</Button>
                <Button variant='contained' color='primary' style={{ width: '80px' }} onClick={this.onClickSave} disabled={!this.state.isDirty && !this.state.isNameDirty}>Save</Button>
            </Grid>
        );
    }

    onIsAssignedChange = (e, rowData) => {
        let affiliateGroupHospitals = this.state.affiliateGroupHospitals.slice();
        let index = affiliateGroupHospitals.findIndex(x => x.idiVetUser === rowData.idiVetUser);
        if (e.target.checked) {
            affiliateGroupHospitals[index].affiliateGroupId = this.props.affiliateGroup.id;
        }
        affiliateGroupHospitals[index].isAssigned = e.target.checked;
        this.setState({
            isDirty: true,
            affiliateGroupHospitals
        });
    }

    isAssignedTemplate = (rowData, props) => {
        return (
            <Checkbox
                checked={rowData.isAssigned}
                onChange={(e) => this.onIsAssignedChange(e, props.rowData)}
                value={`affiliateGroupHospitals[${props.rowIndex}].isAssigned`}
                color="primary"
            />
        );
    }

    isActiveTemplate = (rowData, props) => {
        return (
            <Checkbox
                checked={rowData.isActive}
                value={`affiliateGroupHospitals[${props.rowIndex}].isActive`}
                color="primary"
            />
        );
    }

    renderAffiliateGroupHospitals() {
        if (this.state.loadingHospitals)
            return <em>Loading...</em>;
        return (
            <div>
                <DataTable value={this.state.affiliateGroupHospitals} editable>
                    <Column field="name" header="Name" sortable style={{ width: '5%' }} />
                    <Column field="description" header="Description" sortable style={{ width: '15%' }} />
                    <Column field="amGroup" header="Area Manager Groups" sortable style={{ width: '20%' }} />
                    <Column field="dmGroup" header="District Manager Groups" sortable style={{ width: '20%' }} />
                    <Column field="isAssigned" header="Assign?" body={this.isAssignedTemplate} sortable style={{ textAlign: 'center', width: '5%' }} />
                    <Column field="isActive" header="Active?" body={this.isActiveTemplate} sortable style={{ textAlign: 'center', width: '5%' }} />
                </DataTable>
                <br />
            </div>
        );
    }

    renderDetailsTable() {
        if (this.props.affiliateGroup) {
            return (
                <div>
                    <Grid container spacing={0}>
                        <Grid item xs={3} style={{ marginRight: "0" }}>
                            <TextField
                                label="Affiliate"
                                defaultValue={this.props.affiliateName}
                                disabled fullWidth inputProps={{ maxLength: "50" }}
                            />
                        </Grid>
                        <Grid item xs={3}>
                            <TextField
                                label="Affiliate Group"
                                defaultValue={this.props.affiliateGroup.name}
                                onChange={this.handleChange}
                                readOnly fullWidth inputProps={{ maxLength: "50" }}
                            />
                        </Grid>
                        <Grid item xs={6}>
                            {this.renderDeleteSaveCancel(12)}
                        </Grid>
                    </Grid>
                    <br />
                </div>
            );
        }
    }

    render() {
        let renderDetailsTable = this.renderDetailsTable();
        let affiliateGroupHospitals = this.renderAffiliateGroupHospitals();
        return (
            <div>
                <h3>Affiliate Groups Management</h3>

                <hr />
                {renderDetailsTable}
                <hr />
                {/*filterAndSaveCancel*/}
                <br />

                <br />
                {affiliateGroupHospitals}
                <br />
                {this.renderSaveCancel(12)}
            </div>
        );
    }
}


// WEBPACK FOOTER //
// ./src/components/ManageGroups/AffiliateGroupsEditor.js